import React from "react";

/**
 * Shared stat tile — white card, warm border, centred emoji → big number → caption.
 * Used on dashboard, trophy room, reports, admin.
 */
export default function StatCard({ emoji, value, label, className = "" }) {
  return (
    <div
      className={
        "flex flex-col items-center justify-center gap-1 rounded-card bg-white " +
        "border border-cardline shadow-card px-4 py-4 text-center " +
        className
      }
    >
      {emoji && <span className="text-2xl leading-none">{emoji}</span>}
      <span className="font-display font-semibold text-2xl text-ink leading-none">{value}</span>
      {label && (
        <span className="font-body font-extrabold text-[11px] tracking-wide uppercase text-muted">
          {label}
        </span>
      )}
    </div>
  );
}
